<template>
    <div id="login-modal" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 class="modal-title">Logga in</h4>
                </div>
                <div class="modal-body">
                    <login-form></login-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const LoginForm = require('./login-form.vue');

export default {
    components: {
        LoginForm
    }
};
</script>
